import React from 'react';

export class ScrollDrag extends React.PureComponent {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.posision = {
      isScrolling: false,
      startX: 0,
      scrollLeft: 0
    };
  }

  onMouseDown = (e) => {
    this.posision = {
      ...this.state,
      isScrolling: true,
      startX: e.pageX - this.ref.current.offsetLeft,
      scrollLeft: this.ref.current.scrollLeft
    };
  };

  onMouseUp = () => {
    this.posision = { ...this.state, isScrolling: false };
    this.ref.current.classList.remove('mc-active');
  };

  onMouseMove = (e) => {
    if (!this.posision.isScrolling) return;
    e.preventDefault();
    const x = e.pageX - this.ref.current.offsetLeft;
    const walk = x - this.posision.startX;
    this.ref.current.scrollLeft = this.posision.scrollLeft - walk;
    this.ref.current.classList.add('mc-active');
  };

  render() {
    const { rootClass = '', style = {} } = this.props;
    return (
      <div
        ref={this.ref}
        onMouseDown={this.onMouseDown}
        onMouseLeave={this.onMouseUp}
        onMouseUp={this.onMouseUp}
        onMouseMove={this.onMouseMove}
        className={'mc-scroll-drag ' + rootClass}
        style={style}
      >
        {React.Children.map(this.props.children, (child) => React.Children.only(child))}
      </div>
    );
  }
}
